const thrpyReferralAlertTypes = {
  unSet: -1,
  fromVinculatedStatus: 0,
  initialVinculatedStatus: 1,
  serviceChangeDefinition: 2,
  admissionExpiration: 3,
  serviceExpiration: 4,
};

export default thrpyReferralAlertTypes;
